import { render, staticRenderFns } from "./ClassReports.vue?vue&type=template&id=2610ed8c&scoped=true&"
import script from "./ClassReports.vue?vue&type=script&lang=js&"
export * from "./ClassReports.vue?vue&type=script&lang=js&"
import style0 from "./ClassReports.vue?vue&type=style&index=0&id=2610ed8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2610ed8c",
  null
  
)

export default component.exports